var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlusSmall = function SvgPlusSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#121212",
    d: "M8.577 3.578A.576.576 0 0 0 8 3a.576.576 0 0 0-.577.577v3.846H3.577A.576.576 0 0 0 3 8.001c0 .32.257.577.577.577h3.846v3.846c0 .32.257.577.577.577s.577-.257.577-.577V8.578h3.846c.32 0 .577-.257.577-.577a.576.576 0 0 0-.577-.577H8.577z"
  })));
};
export default SvgPlusSmall;